// Field labels from the live catalogue, ready to pass to `fieldLabel`/
// `describeRule`/`describeFilterTree` — every surface that renders a field
// label wants the same `useFields()` + `labelsFromFields` derivation.
import { useMemo } from "react";
import { useFields } from "./useFields";
import { labelsFromFields } from "../lib/filterLogic";

export function useCatalogueLabels(): Record<string, string> {
  const { fields } = useFields();
  return useMemo(() => labelsFromFields(fields), [fields]);
}
